var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcScores(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EEF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5C16.5 15.8086 15.9414 15.25 15.25 15.25C14.5586 15.25 14 15.8086 14 16.5V29.625C14 31.3516 15.3984 32.75 17.125 32.75H32.75C33.4414 32.75 34 32.1914 34 31.5C34 30.8086 33.4414 30.25 32.75 30.25H17.125C16.7812 30.25 16.5 29.9688 16.5 29.625V16.5ZM32.3828 19.8828C32.8711 19.3945 32.8711 18.6016 32.3828 18.1133Cnan nan 31.1016 17.625 30.6133 18.1133L26.5 22.2305L24.2578 19.9883C23.7695 19.5 22.9766 19.5 22.4883 19.9883L18.1133 24.3633C17.625 24.8516 17.625 25.6445 18.1133 26.1328Cnan nan 19.3945 26.6211 19.8828 26.1328L23.375 22.6445L25.6172 24.8867C26.1055 25.375 26.8984 25.375 27.3867 24.8867L32.3867 19.8867L32.3828 19.8828Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScores);
export default __webpack_public_path__ + "static/media/ic_scores.8c8a967f9d8ccc5200252bffa7653b25.svg";
export { ForwardRef as ReactComponent };